<template>
  <div class="primary-theme impact c-fluid" id="impact">
    <div class="row">
      <div class="col-sm-12 col-lg-8 px-0 row">
        <div class="col-3 title-line yellow my-auto"></div>
        <div class="col-4 title-text my-auto text-center">O U R &nbsp; I M P A C T</div>
        <div class="col-5 title-line yellow my-auto"></div>
      </div>
    </div>
    <div class="section-content">
      <h1 class="quote">we invest in a better tomorrow for the people and the planet</h1>
      <div class="row mx-auto">
        <div class="col-6 col-lg-3 mb-4 text-center" v-for="(val, index) in list" :key="index">
          <h2 class="stat yellow-text">{{val.stat}}</h2>
          <p>{{val.description}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "./../data/data";
export default {
  name: "Impact",
  data() {
    return {
      list: data.impact
    };
  }
};
</script>

<style scoped>
.impact {
  background-image: url("/static/imgs/impact.png");
  background-size: cover;
}
.stat {
  font-family: Mahoni;
  font-size: 4rem;
}

@media screen and (max-width: 700px) {
  .stat {
    font-size: 2rem;
  }
}
@media screen and (min-width: 701px) {
  .stat {
    font-size: 4rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Impact.vue